export default "__VITE_ASSET__DJbLTv7k__"